import $ from 'jquery';

export default class AddToBasket {
    constructor(params) {
        this.addToBasketPopupProduct = params.addToBasketPopupProduct;
        this.addingItemToBasketText = params.addingItemToBasketText;
        this.addToBasketTrigger = params.addToBasketTrigger;
    }

    init() {
        $(document).ready(() => {
            this.setup();
        });
    }

    setup() {
        let me = this;
        me.initSelectors();
        me.initEvents();

        //@todo this can be removed once DSB has been overhauled
        // If addToBasketPopupProduct is set, product was added on last request and we just need to display the popup
        if (me.addToBasketPopupProduct) {
            me.importAddToBasketPopup(me.addToBasketPopupProduct, null);
        }

        if (me.addToBasketTrigger) {
            me.$formOffCanvas.submit();
        }

        $(window).on('JBG.productListChange JBG.productDisplayChange', function () {
            if (me.addToBasketPopup === undefined) {
                me.initSelectors();
                me.initEvents();
            }
        });
    }

    initSelectors() {
        //@TODO consider splitting this into two separate files. Need to refactor app.js as it probably isn’t needed on every single page now list views can’t add to cart
        this.$formOffCanvas = $('form.add-to-basket, .addtocart > form');
        this.$formQRPopup = $('form.add-to-basket-qr-popup');
    }

    initEvents() {
        let me = this;

        me.$formOffCanvas.on('submit', function (e) {
            e.preventDefault();
            let form = $(this);
            me.importAddToBasketOffCanvas(null, form);
        });

        me.$formQRPopup.on('submit', function (e) {
            e.preventDefault();
            let form = $(this);
            me.importQRPopup(null, form);
        });
    }

    importAddToBasketPopup(product, form) {
        let text = this.addingItemToBasketText;

        import('./addToBasketPopup').then((AddToBasketPopup) => {
            this.addToBasketPopup = new AddToBasketPopup.default(product, form, text);
            this.addToBasketPopup.init();
        });
    }

    importAddToBasketOffCanvas(product, form) {
        let text = this.addingItemToBasketText;
        import('./addToBasketOffCanvas').then((AddToBasketOffCanvas) => {
            this.$formOffCanvas.off('submit');
            this.addToBasketOffCanvas = new AddToBasketOffCanvas.default(product, form, text);
            this.addToBasketOffCanvas.init();
        });
    }

    importQRPopup(product, form) {
        let text = this.addingItemToBasketText;

        import('./addToBasketQRPopup').then((AddToBasketQRPopup) => {
            this.$formQRPopup.off('submit');
            this.addToBasketQRPopup = new AddToBasketQRPopup.default(product, form, text);
            this.addToBasketQRPopup.init();
        });
    }
}